import PropTypes from 'prop-types';
import css from './ImpersonationFooter.scss';

const ImpersonationFooter = ({impersonationInfo, loggedInMemberId}) => {
    return (
        <div className={css.impersonationFooter}>
            <span>Impersonator ID: {impersonationInfo.impersonatorTypeId}</span>
            <span>Impersonator type: {impersonationInfo.impersonatorType}</span>
            <span>Impersonated ID: {loggedInMemberId}</span>
            <span>Impersonated type: {impersonationInfo.impersonatedType}</span>
        </div>
    );
};

ImpersonationFooter.propTypes = {
    impersonationInfo: PropTypes.shape({
        impersonatorTypeId: PropTypes.string.isRequired,
        impersonatorType: PropTypes.string.isRequired,
        impersonatedType: PropTypes.string.isRequired,
    }).isRequired,
    loggedInMemberId: PropTypes.string.isRequired,
};

export default ImpersonationFooter;
